import Vue from "vue";

const getLodash = require('lodash/get');
const setLodash = require('lodash/set');

export default {
    data: () => ({
        disableSetPassword: false
    }),
    methods: {
        setData(dataAttribute, dataKeys, resource, resourceKeys) {
            dataKeys.forEach((key, ketIndex) => {
                setLodash(this[dataAttribute], key, getLodash(resource, resourceKeys[ketIndex]));
            });
        },
        getDataObject(dataKeys, resource, resourceKeys) {
            let dataObj = {};

            dataKeys.forEach((key, ketIndex) => {
                setLodash(dataObj, key, getLodash(resource, resourceKeys[ketIndex]));
            });

            return dataObj;
        },
        setNewPassword(userId) {
            this.disableSetPassword = true;

            this.resetPassword(userId)
                .then(() => {
                    this.$appNotify.success(Vue.prototype.$lang('userEdit.success'));
                })
                .finally(() => {
                    this.disableSetPassword = false;
                })
        },
    }
}
